<template lang="html">
  <div ref="levels_indicator" class="levels-indicator">
     <div class="levels-indicator__barrita">
       <div class="levels-indicator-bar"></div>
      <el-row :gutter="20">
        <el-col :span="8" style="">
        <div ref="first_cicle" class="levels-indicator__circle circle-centered"
        v-bind:class="{ selectedFirst:selectedFirst  }"></div>
        </el-col>
        <el-col :span="8">
          <div ref="second_cicle" class="levels-indicator__circle circle-centered visibility-hidden"
        v-bind:class="{ selectedSecond:selectedSecond }"></div>
        </el-col>
        <el-col :span="8">
        <div ref="third_cicle" class="levels-indicator__circle circle-centered"
        v-bind:class="{ selectedThird:selectedThird  }"></div>
        </el-col>
      </el-row>
    </div>
    <div class="levels-indicator__text">
      <el-row :gutter="20">
        <el-col :span="8" style="">
        <p style="text-align:center;">SIN BURSATILIDAD</p>
        </el-col>
        <el-col :span="8">
        <p style="text-align:center;">{{ dinamicText }}</p>
        </el-col>
        <el-col :span="8">
        <p style="text-align:center;">ALTA</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/* Imports are written here */
export default {
  components: {},
  props: {
    graph_data: String
  },
  data() {
    return {
      selected: String,
      selectedFirst: false,
      selectedSecond: false,
      selectedThird: false,
      selectedFourth: false,
      dinamicText: "",
      drawText: ["MEDIA", "BAJA", "MINIMA", "NULA"]
    };
  },
  computed: {},
  watch: {
    graph_data: "updateComponent",
    selected: "updateComponent"
  },
  methods: {
    updateComponent() {
      this.selected = this.graph_data;
      this.drawSelection();
    },
    cleanCircles() {
      this.selectedFirst = false;
      this.selectedSecond = false;
      this.selectedThird = false;
    },
    drawSelection() {
      if (this.selected == "NA") {
        this.$refs.levels_indicator.style.display = "none";
        this.$emit("hideText");
      } else if (this.selected == "SIN BURSATILIDAD") {
        this.selectedFirst = true;
      } else if (this.selected == "ALTA") {
        this.selectedThird = true;
      } else {
        for (let element of this.drawText) {
          if (this.selected == element) {
            this.selectedSecond = true;
            this.dinamicText = element.toUpperCase();;
          }
        }
      }
    }
  },
  beforeMount() {},
  mounted() {
    this.updateComponent();
  }
};
</script>

<style lang="css" scoped>
.levels-indicator {
  height: 58px;
  width: 100%;
  display: block;
  box-sizing: border-box;
}

.levels-indicator p {
  margin: 14px 0 0 0;
  font-size: 10px;
}

.levels-indicator-bar-section {
  width: 370px;
  margin-left: 56px;
  margin-right: auto;
  display: flex;
}

.levels-indicator-bar {
  width: 318px;
  height: 8px;
  background-color: #e7e7e7;
  display: block;
  margin-top: 4px;
  border-radius: 5px;
  position: absolute;
  margin-left: 66px;
  z-index: 0;
}

.levels-indicator__container-circle {
  display: inline-block;
  width: 33.33%;
  margin-top: 2px;
}

.levels-indicator__circle {
  width: 16px;
  height: 16px;
  border: 2px #e7e7e7 solid;
  border-radius: 25px;
  background-color: white;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.circle-centered {
  transform: translateX(-50%);
  left: 50%;
}

.circle-right {
  float: right;
}

.levels-indicator__text {
  width: 450px;
}

.levels-indicator__barrita {
  width: 450px;
}

.levels-indicator__container-text {
  display: inline-block;
  width: 32.82%;
}

.text--center {
  text-align: center;
}

.text--right {
  text-align: right;
}

.visibility-hidden {
  visibility: hidden;
}

.selectedFirst {
  background-color: #60a114;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
}

.selectedSecond {
  visibility: visible;
  background-color: #F8BF1C;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
}

.selectedThird {
  background-color: #60a114;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/LevelsIndicator.vue